import {AfterViewInit, Component, ElementRef, NgZone, OnDestroy, OnInit, ViewChild} from '@angular/core'
import {MlVsService} from './ml.vs.service'
import {environment} from '../../../../environments/environment'
import {VendorSearch} from '../../interfaces/vendor-details'
import {BuiltInCategory} from '../../interfaces/common'
import {NotificatorService} from '../../services/notificator.service'
import {ActivatedRoute, Router} from '@angular/router'
import {Subscription} from 'rxjs'
import {IdbCache} from '../../services/cache.etc/idb.cache'
import {Vendors} from '../../../components/vendor.items/list/list.service'

@Component({
    selector: 'app-ml-vendor-selector',
    templateUrl: './ml-vendor.search.component.html',
    styleUrls: ['./ml-vendor.search.component.css'],
    standalone: false
})

export class MlVendorSearchComponent implements OnInit, OnDestroy, AfterViewInit {
  VCS: Subscription
  @ViewChild('VendorSearchInput') vendorSearchInput: ElementRef
  internalEvent: boolean

  currentShow = 'BANNER'   // BANNER || FORM
  vendorSelected: boolean
  currentVendor: VendorSearch
  // currentVendor: VendorDetails | VendorSearch;
  foundVendors: Array<VendorSearch> = []
  vsLoading: boolean
  lastTerm: string
  // For Manual Select
  vendorList = (() => {
    const result: Record<string, Vendors[]> = {}
    for (const item of environment.categoriesList) {
      result[item.api] = []
    }
    return result
  })()
  formType = ''  // MANUAL || SEARCH
  categoriesList = environment.categoriesList
  choosedCategory: BuiltInCategory = {
    name: null,
    altName: null,
    plural: null,
    api: null,
    id: null,
    ids: null,
    icon: '',
    pseudoCategory: null,
    isDining: false
  }
  nzFilterOption = () => true

  /**
   * Процедура установки вендора и загрузка его данных в кеш
   * @param isSearch - bool
   */
  setVendor(isSearch?: boolean) {
    this.internalEvent = true
    setTimeout(() => {
      this.formType = ''
      this.currentShow = 'BANNER'
      this.vendorSelected = true
      // console.log('chosen vendor: ', this.currentVendor)
      this.SRV.setVendor(this.currentVendor).subscribe(() => {
        if (environment.isHotel(this.currentVendor.vendor)) {
          this.router.navigate(['/hotel-schedules'])
        } else {
          this.router.navigate(['/schedules'])
        }
        // this.notify.createTopMessage('Selected Vendor has been saved to cache', 'info', 1000)
        if (isSearch) {
          this.SRV.saveTerm(this.currentVendor.vendor.category, this.currentVendor.vendor.vendorId, this.lastTerm)
        }
      })
    }, 100)
  }

  /**
   * Reset selected vendor
   */
  resetVendor() {
    this.internalEvent = true
    const redirectFrom = [
      '/schedules',
      '/vendor',
      '/vendor/products',
      '/rates',
      '/allotments',
      '/schedules',
      '/hotel-schedules',
      '/availability'
    ]
    this.zone.run(() => {
      // console.log('this.router: ', this.router, this.router.url)
      if (
        redirectFrom.find(i => {
          return this.router.url.indexOf(i) >= 0
        })
      ) {
        this.router.navigate(['/dashboard'])
      }
      this.SRV.setVendor(null, true).subscribe(() => {
        this.vendorSelected = false
        localStorage.removeItem('VS.vendorSelected')
        // console.log('VENDOR UNSELECTED')
      })
    })
  }

  goBackToChooseCategory() {
    this.choosedCategory = {
      name: null,
      altName: null,
      plural: null,
      api: null,
      id: null,
      ids: null,
      icon: '',
      pseudoCategory: null,
      isDining: false
    }
  }

  search(value: string): void {
    if (environment.stringCheck(value) && value.length >= 0) {
      this.vsLoading = true
      this.lastTerm = value
      this.SRV.vendorSearch(value).subscribe(data => {
        this.foundVendors = data
        this.vsLoading = false
      })
    }
  }

  clickOnBanner(isBlur?: boolean) {
    if (isBlur) {
      setTimeout(() => {
        this.currentShow = 'BANNER'
        this.formType = ''
      }, 300)
    } else {
      this.currentShow = 'FORM'
      this.formType = 'SEARCH'
      setTimeout(() => {
        // console.log('VSE: ', this.vendorSearchInput)
        // ng-zorro autofocus workaround: open search input
        ;(document.querySelector('#vsi input') as HTMLInputElement | null)?.click()
      }, 100)
    }
  }

  /**
   * Open V2 from V1.properties with set vendor in vendor.search
   */
  interceptVendorChangeFromOldVersion(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.aRouter.queryParams.subscribe(qp => {
        if (Object.keys(qp).includes('authAsVendor')) {
          const vd = qp.authAsVendor.split(':')  // Incoming format -> categoryId:vendorId (example: 5:12345678)
          this.SRV.vendorSearch(vd[1]).subscribe(data => {
            if (data.length > 0) {
              this.currentVendor = data.find(t => t.vendor.vendorId === vd[1] && t.vendor.category === vd[0])
              this.setVendor(true)
              setTimeout(() => {
                this.router.navigate(['/dashboard'])
              }, 123)
              resolve(true)
            } else {
              reject(false)
            }
          })
        } else {
          reject(false)
        }
      }, error => {
        console.log('.cc-error: ', error)
        reject(false)
      })
    })
  }

  initUI(data: VendorSearch | null | undefined) {
    if (this.internalEvent) {
      this.internalEvent = false
      return
    }
    if (data) {
      this.currentVendor = data
      this.vendorSelected = true
    } else {
      // this.SRV.getCV().then(v => {
      //   console.log('vendor-init-service: ', v)
      // }, error => console.log('vendor not selected or', error))
    }
  }

  subscriptionOnPickVendor() {
    this.VCS = this.SRV.selectedVendor.subscribe(data => {
      // console.log('sub on change vendor:', data)
      this.initUI(data)
    })
  }

  initService() {
    this.subscriptionOnPickVendor()
    this.SRV.getCV().then(data => {
      // console.log('first init - upd vd:', data)
    }, e => {
      console.warn('VENDOR-NOT-DEFINED')
    })
    //
    // for (const category of environment.categoriesList) {
    //   const cc = category.api === null ? category.pseudoCategory : category.api
      // this.SCS.getVendorByCategory(cc).subscribe(vData => {
      // this.IDBC.getVendorForms(cc).then(vData => {
      //   this.vendorList[cc] = vData
      // })
    // }
    // Update 2024-04-24
    this.IDBC.getVendorForms().then(vendors => {
      vendors.forEach(vi => {
        if (this.vendorList[environment.categoryDec2Str(vi.vendor.category).api]) {
          this.vendorList[environment.categoryDec2Str(vi.vendor.category).api].push(vi)
        } else {
          this.vendorList[environment.categoryDec2Str(vi.vendor.category).api] = [vi]
        }
      })
    })
  }

  constructor(
    private SRV: MlVsService,
    private IDBC: IdbCache,
    // private SCS: CacheService,
    private notify: NotificatorService,
    private aRouter: ActivatedRoute,
    private router: Router,
    private zone: NgZone
  ) {
  }

  ngOnInit() {
    // console.log('Init MLVS cmp', this)
  }

  ngOnDestroy() {
    if (this.VCS) {
      this.VCS.unsubscribe()
    }
  }

  ngAfterViewInit() {
    this.interceptVendorChangeFromOldVersion().then(s => {
      this.initService()
    }, e => this.initService())
  }
}

